
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


export const notifySuccess = (message, dark) =>
  toast(<p style={{ fontSize: 14, display: "flex", justifyContent: "center", margin: "auto", fontFamily: 'Poppins, Helvetica, "sans-serif"' }}>{message}</p>, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: "success"
  });
export const notifyType = (message, type, dark) =>
  toast(<p style={{ fontSize: 14, display: "flex", justifyContent: "center", margin: "auto", fontFamily: 'Poppins, Helvetica, "sans-serif"', zIndex: "99999" }}>{message}</p>, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: type
  });
export const notifyError = (message, dark) =>
  toast(<p style={{ fontSize: 16, display: "flex", justifyContent: "center", margin: "auto", fontFamily: 'Poppins, Helvetica, "sans-serif"' }}>{message}</p>, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    className: dark ? "custom-toast-dark" : "",
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: "error"
  });


export function allowOnlyNumbers(e) {
  if (e.type === "keydown") {
    // Allow control shortcuts (Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+A)
    if (e.ctrlKey || e.metaKey) {
      return; // do NOT block
    }

    const allowed =
      (e.key >= "0" && e.key <= "9") ||
      ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key);

    if (!allowed) {
      e.preventDefault();
    }
  }

  if (e.type === "paste") {
    const pasteData = e.clipboardData.getData("text");
    if (!/^\d+$/.test(pasteData)) {
      e.preventDefault();
    }
  }
}

export const validateStartAndEndDate = (startDate, endDate) => {
  // if (!startDate || !endDate) return ""; // Skip validation if either is missing

  const start = new Date(startDate);
  const end = new Date(endDate);
  if ((end < start) || (endDate && !startDate)) {
    return false;
  }

  return true;
};

export const handleVenderLogOut = () => {
  Cookies.remove("NIGHT_EYE_JWT_TOKEN")
  Cookies.remove("NIGHT_EYE_USER_ID")
  Cookies.remove("NIGHT_EYE_USER_ROLE")
  Cookies.remove("NIGHT_EYE_USER_NAME")
  Cookies.remove("NIGHT_EYE_USER_TOKEN_UNIQUE_ID")
}
export const handleDepartmentLogOut = () => {
  Cookies.remove("VenderMobileNo")
  Cookies.remove("NIGHT_EYE_SHOP_DETAIL_ID")
  Cookies.remove("IsStep1Completed")
  Cookies.remove("IsStep2Completed")
  Cookies.remove("IsStep3Completed")
  Cookies.remove("NIGHT_EYE_JWT_TOKEN")
  Cookies.remove("NIGHT_EYE_USER_TOKEN_UNIQUE_ID")
  Cookies.remove("NIGHT_EYE_USER_ID")
  Cookies.remove("DP_NIGHT_EYE_USER_ROLE")
  Cookies.remove("NIGHT_EYE_CITY_ID")
  Cookies.remove("NIGHT_EYE_ZONE_ID")
  Cookies.remove("NIGHT_EYE_POLICE_STATION_ID")
  Cookies.remove("NIGHT_EYE_AREA_ID")
  Cookies.remove("VENDER_NIGHT_EYE_USER_ID")
  Cookies.remove("DP_NIGHT_EYE_USER_NAME")
}

// export const exportToExcel = async (data, fileName = 'websites') => {
export const exportToExcel = async (data, fileName) => {
  if (!data || data.length === 0) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(fileName);

  const headers = Object.keys(data[0]);
  const borderColor = 'FFCCCCCC'; // Light gray border

  // Add header row with styles
  const headerRow = worksheet.addRow(headers);
  headerRow.eachCell(cell => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF2F75B5' } // Blue header background
    };
    cell.border = {
      top: { style: 'thin', color: { argb: borderColor } },
      bottom: { style: 'thin', color: { argb: borderColor } },
      left: { style: 'thin', color: { argb: borderColor } },
      right: { style: 'thin', color: { argb: borderColor } }
    };
  });

  // Add data rows with light gray borders
  data.forEach(item => {
    const row = worksheet.addRow(headers.map(h => item[h]));
    row.eachCell(cell => {
      cell.alignment = { vertical: 'middle', horizontal: 'left' };
      cell.border = {
        top: { style: 'thin', color: { argb: borderColor } },
        bottom: { style: 'thin', color: { argb: borderColor } },
        left: { style: 'thin', color: { argb: borderColor } },
        right: { style: 'thin', color: { argb: borderColor } }
      };
    });
  });

  // Auto-fit column widths
  worksheet.columns.forEach(col => {
    let maxLength = 10;
    col.eachCell({ includeEmpty: true }, cell => {
      const len = cell.value ? cell.value.toString().length : 0;
      if (len > maxLength) maxLength = len;
    });
    col.width = maxLength + 2;
  });

  // Save the file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};